// packages / index.js
// 导入单个组件
import VueEchartsEditor from './VueEchartsEditor'

// 以数组的结构保存组件，便于遍历
const components = [
  VueEchartsEditor
]

// 定义 install 方法
const install = (Vue, options) => {
  if (install.installed) return false
  install.installed = true
  // 遍历并注册全局组件
  components.forEach(component => {
    component.install(Vue, options)
  })
}
if (typeof window !== 'undefined' && window.Vue && window.vueEchartsEditorOptions) {
  install(window.Vue, window.vueEchartsEditorOptions)
}

export default {
  // 导出的对象必须具备一个 install 方法
  install,
  VueEchartsEditor
  // 组件列表
}
